  <div class="modal-body backorder-email">
    <div class="head px-5 py-4 rounded-5 mb-5">
      <img src="../../../../assets/images/sums_logo.svg" style="max-width: 8.8rem" />
    </div>
    <div class="content px-2">
      <h1 class="mb-4">Substitute Product Approval Required</h1>
      <p class="fs-5 mb-3 text-muted">
        Hi, <span class="fw-medium text-primary">{{email}}</span>
      </p>
      <p class="text-danger mb-3 fw-light">
        Following are the suggested substitutes in case a product is backordered, pre-approved substitutes allow us to
        fulfil and ship products faster.
      </p>
      <p class="text-muted mb-3 fw-light">
        Please review the proposed substitutes below, you can approve the suggested substitution rule or request for
        more information if more details are required
      </p>
    </div>
    <div class="pb-3">
      <svg xmlns="http://www.w3.org/2000/svg" width="456" height="1" viewBox="0 0 520 1" fill="none">
        <path d="M0 0.5H520" stroke="#ECEFF3" stroke-dasharray="8 8" />
      </svg>
    </div>
    <div class="manage-user-list">
      <div class="edit-users">
        <div *ngFor="let data of products; let i = index">
          <div class="edit-card card">
            <div class="card-head py-4">
              <h4 class="head-title">
                Product Substitute Request
                <span class="badge border text-dark py-1">0{{ i + 1 }}</span>
              </h4>
            </div>
            <div class="card-body py-4">
              <ng-container>
                <div class="order-add mb-2">
                  <p>
                    <span> Original Product </span>
                  </p>
                </div>
                <div class="row">
                  <div class="col-3">
                    <span class="order-img p-0">
                      <img src="{{
                          data?.product?.imageUrl ||
                            'https://placehold.co/600x400?text=No+Image'
                        }}" alt="No image" class="border p-3 rounded-4" />
                    </span>
                  </div>

                  <div class="col-8">
                    <div class="order-add mt-3 mb-2">
                      <p class="fw-bold fs-5 lh-normal">
                        {{ data?.product?.name || "N/A" }}
                      </p>
                    </div>

                    <div class="order-add mb-2">
                      <p class="text-muted">
                        {{ data?.product?.code || "N/A" }}
                      </p>
                    </div>

                    <div class="order-add mb-0">
                      <p>${{ utils.twoDecimalPlacesString(data?.product?.price || "0") }}</p>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container>
                <div class="order-add mb-2">
                  <p>
                    <span class="text-warning"> Recommended Substitute </span>
                  </p>
                </div>
                <div class="row">
                  <div class="col-3">
                    <span class="order-img p-0">
                      <img src="{{
                          data?.substituteProduct?.imageUrl ||
                            'https://placehold.co/600x400?text=No+Image'
                        }}" alt="No image" class="border p-3 rounded-4" />
                    </span>
                  </div>

                  <div class="col-8">
                    <div class="order-add mt-3 mb-2">
                      <p class="fw-bold fs-5 lh-normal">
                        {{ data?.substituteProduct?.name || "N/A" }}
                      </p>
                    </div>

                    <div class="order-add mb-2">
                      <p class="text-muted">
                        {{ data?.substituteProduct?.code || "N/A" }}
                      </p>
                    </div>

                    <div class="order-add mb-0 d-flex gap-2">
                      <p>${{  utils.twoDecimalPlacesString(data.substituteProduct?.price || "0") }}</p>
                      <p [ngClass]="{
                          'text-success':
                            (data.substituteProduct?.price || 0) <
                            getOriginalProductPrice(data),

                          'text-danger':
                            (data.substituteProduct?.price || 0) >
                            getOriginalProductPrice(data)
                        }">
                        {{ getPriceComparison(
                        getOriginalProductPrice(data),
                        data.substituteProduct?.price || 0
                        ) }}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-container>

              <div class="d-flex gap-4 align-items-center mt-3">
                <button class="btn btn-primary w-100">Approve(Requires Approval)</button>
                <button class="btn btn-primary w-100">Approve(Auto Swap)</button>
              </div>

              <div class="d-flex gap-4 align-items-center mt-3">
                <button class="btn btn-secondary w-100 text-nowrap">
                  Request More Info
                </button>
                <button class="btn btn-secondary text-danger w-100">
                  Decline
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="px-3">
      <!-- <div class="pb-3">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="456"
          height="1"
          viewBox="0 0 520 1"
          fill="none"
        >
          <path d="M0 0.5H520" stroke="#ECEFF3" stroke-dasharray="8 8" />
        </svg>
      </div> -->
      <!-- <div class="head px-5 py-4 rounded-4 mb-5">
        <h3>Note from Reali Team</h3>
        <p>Lorem ipsum</p>
      </div> -->
      <div class="pb-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="456" height="1" viewBox="0 0 520 1" fill="none">
          <path d="M0 0.5H520" stroke="#ECEFF3" stroke-dasharray="8 8" />
        </svg>
      </div>

      <p class="text-muted mb-0 fw-light">
        If no action is taken, substitute requests will remain in <strong class="text-dark">Pending
          Approval</strong> status and will not be automatically applied to future orders.
      </p>

      <div class="pb-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="456" height="1" viewBox="0 0 520 1" fill="none">
          <path d="M0 0.5H520" stroke="#ECEFF3" stroke-dasharray="8 8" />
        </svg>
      </div>

      <div class="d-flex align-items-center gap-5">
        <p class="text-muted fs-5">
          Send us Email
          <br />
          <span class="text-dark fs-6">sales@reali.au</span>
        </p>
        <p class="text-muted fs-5">
          CALL US on
          <br />
          <span class="text-dark fs-6">1300107233</span>
        </p>
      </div>

      <div class="pb-0">
        <svg xmlns="http://www.w3.org/2000/svg" width="500" height="1" viewBox="0 0 520 1" fill="none">
          <path d="M0 0.5H520" stroke="#F68C1E" stroke-dasharray="8 8" />
        </svg>
      </div>

      <p class="text-warning mb-0 fw-light fs-5">
        SUMS: Smart Uniform Management System
      </p>

      <div class="pb-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="500" height="1" viewBox="0 0 520 1" fill="none">
          <path d="M0 0.5H520" stroke="#F68C1E" stroke-dasharray="8 8" />
        </svg>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="d-flex justify-content-end mt-4">
      <button class="btn btn-primary" (click)="sendBulkApprovalRequest()">
        Send Approval Request
      </button>
    </div>
  </div>
